import React, { useEffect, useState } from 'react';
import { Stack, Box, Typography } from '@mui/material';
import { useWallet } from '@solana/wallet-adapter-react';
import { getHistories } from '../api/bot.api';
import { displayWithNonZeroDecimals, formatDateTime, shortenAddress } from '../libs/utils';
import CopyButton from './CopyButton';

export interface HistoryInterface {
    _id: string;
    txType: string;
    pubkey: string;
    signupAddress: string;
    amount: number;
    txStatus: string;
    txId: string;
    rewards: any[];
    nftMint: string;
    createdAt: string;
}


export default function HistoryContainer() {
    const { publicKey } = useWallet();
    const [histories, setHistories] = useState<HistoryInterface[]>([]);

    const getHistoriesHandler = async () => {
        const res = await getHistories({});
        if(res.success){
            setHistories(res.data);
        }
    }
    
    useEffect(() => {
        if (publicKey) {
            getHistoriesHandler();
            const interval = setInterval(() => {
                getHistoriesHandler();
            }, 20000);
            
            return () => clearInterval(interval); // Cleanup on unmount
        }
    }, [publicKey]);

    return (
        <Box sx={{display: 'flex', flexDirection: 'column', width: '100%', overflowY: 'auto', flex: 1,
            '& table': {
                border: '1px solid blue',
                borderColor: 'divider',
                borderRadius: '12px 12px 0 0',
                borderBottom: 'none',
                thead: {
                    height: '50px',
                    position: 'sticky',
                    top: 0,
                    backgroundColor: '#1a1a1a',
                    borderRadius: '12px',
                    zIndex: 1,
                },
                th: {
                    color: 'text.disabled',  
                },
                tr: {
                    height: '50px',
                },
                td: {
                    textAlign: 'center',
                    borderBottom: '1px solid blue',
                    borderBottomColor: 'divider',
                },
                '& .hide-xs': {
                    display: { xs: 'none', md: 'table-cell' }
                }
            },
            }}>
            <table>
                <thead>
                    <tr>
                        <th>Date</th>
                        <th>Investor</th>
                        <th className='hide-xs'>Signup Address</th>
                        <th>
                            <Stack direction="column" alignItems="center" justifyContent="center">
                                Amount
                                <Typography variant='caption'>USDC</Typography>
                            </Stack>
                        </th>
                        <th className='hide-xs'>NFT ID</th>
                    </tr>
                </thead>
                <tbody>
                    {histories.map((info) => (
                        <tr key={info._id}>
                            <td>{formatDateTime(info.createdAt)}</td>
                            <td>
                                <Stack direction="row" alignItems="center" justifyContent="center">
                                    {shortenAddress(info.pubkey, 4)}
                                    <CopyButton text={info.pubkey}/>
                                </Stack>
                            </td>
                            <td className='hide-xs'>
                                <Stack direction="row" alignItems="center" justifyContent="center">
                                    {shortenAddress(info.signupAddress, 4)}
                                    <CopyButton text={info.signupAddress}/>
                                </Stack>
                            </td>
                            <td>{displayWithNonZeroDecimals(info.amount)}</td>
                            <td className='hide-xs'>
                                <Stack direction="row" alignItems="center" justifyContent="center">
                                    {shortenAddress(info.nftMint, 4)}
                                    <CopyButton text={info.nftMint}/>
                                </Stack>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </Box>
            
    );
}